var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrinkAlt1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.341,5.125A2.985,2.985,0,0,0,19,4H14.673L14.8,2.89A1,1,0,0,1,15.79,2H20a1,1,0,0,0,0-2H15.79a3,3,0,0,0-2.981,2.669L12.661,4H5A3.02,3.02,0,0,0,2.056,7.556L3.568,19.622A5.008,5.008,0,0,0,8.529,24H15.47a5.01,5.01,0,0,0,4.962-4.379l1.5-11.968A2.982,2.982,0,0,0,21.341,5.125ZM19,6a1,1,0,0,1,.781.375,1.068,1.068,0,0,1,.179.937L19.622,10H14.006l.445-4ZM4.221,6.374A1,1,0,0,1,5,6h7.437l-.445,4H4.374l-.35-2.784A.993.993,0,0,1,4.221,6.374Zm14.226,13A3.005,3.005,0,0,1,15.47,22H8.529a3,3,0,0,1-2.976-2.626L4.626,12H19.371ZM13.438,15.11l-.444,4a1,1,0,1,1-1.988-.22l.444-4a1.014,1.014,0,0,1,1.105-.884A1,1,0,0,1,13.438,15.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkAlt1);
export default __webpack_public_path__ + "static/media/drink-alt (1).79f27530633a8454ac31d6829e510be0.svg";
export { ForwardRef as ReactComponent };